import { ReactNode } from 'react';

type Tone = 'success' | 'error' | 'warning' | 'info';

const tones: Record<Tone, string> = {
  success: 'bg-green-50 dark:bg-green-900/25 text-green-800 dark:text-green-300 border-green-200 dark:border-green-800',
  error: 'bg-red-50 dark:bg-red-900/25 text-red-800 dark:text-red-300 border-red-200 dark:border-red-800',
  warning: 'bg-amber-50 dark:bg-amber-900/25 text-amber-800 dark:text-amber-300 border-amber-200 dark:border-amber-800',
  info: 'bg-brand-50 dark:bg-brand-900/25 text-brand-800 dark:text-brand-300 border-brand-200 dark:border-brand-800',
};

/**
 * Inline message block. Replaces a dozen hand-copied
 * `bg-red-50 dark:bg-red-900/30 …` divs that had drifted apart.
 */
export function Alert({ tone = 'info', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={`px-4 py-3 rounded-md border text-sm ${tones[tone]}`}
    >
      {children}
    </div>
  );
}
